export default __webpack_public_path__ + "static/media/supplier-login-welcome.7bb5d63d.png";